import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productCategoryPaginate',
    serviceName: 'graphql',
    query: gql`
      query productCategoryPaginate($ids: [String], $for_admin: Int) {
        productCategoryPaginate(ids: $ids, for_admin: $for_admin) {
          data {
            title
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProductCategory',
    serviceName: 'admin',
    query: gql`
      mutation updateProductCategory($ids: [String]!, $title: String) {
        updateProductCategory(ids: $ids, title: $title) {
          messages
        }
      }
    `,
  },
};

export default schema;
